/* eslint-disable max-lines */
/* eslint-disable react/jsx-one-expression-per-line */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Fonts, Spacings } from '@styles/index';
import H2 from '@base/H2/H2';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import Image from '@base/Image';

const Home = styled.a`
  color: var(--color-i-blue);
`;

const StyledAnchor = styled(Home)`
  margin-left: ${Spacings.SPACING_1B};
`;

const Line = styled.li`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: var(--color-text-primary);
  margin: 0px;
`;

const CombatTerms = styled.div`
  width: 100%;
  margin: ${Spacings.SPACING_2B} 0;
`;

const Terms = () => {
  const { pathname, query } = useRouter();
  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>
      <RightContainer>
        {query.in_app !== 'true' && (
          <H2 as="h1">Terms & Conditions – Unacademy Combat</H2>
        )}
        <br />
        <br />
        <br />
        <ol>
          <Line>
            Unacademy Combat Contest(s) (“Contest(s)”) are organized by Sorting
            Hat Technologies Private Limited (“Unacademy”) to assist learners in
            assessing their preparedness for various competitive exams.
          </Line>
          <Line>
            The Contest(s) are governed by these Terms and Conditions, the
            online Privacy Policies and Community Guidelines available on the
            Unacademy website (<Home href="/">www.unacademy.com</Home>) as may
            be amended from time to time at the discretion of Unacademy.
          </Line>
          <Line>
            Participation in the Contest(s) is voluntary. By participating in
            the Contest(s) Participants are agreeing to the terms and conditions
            stated herein.
          </Line>
          <Line>
            Individual learners (hereinafter referred to “Participants”) are
            eligible to participate in the Contest(s) in accordance with the
            eligibility criteria specified below.
          </Line>
          <Line>
            To be eligible to take part in the Contest(s), Participants must
            conform to the following eligibility criteria:
            <ol type="a">
              <Line>
                Be an Individual and participating for themselves and to gauge
                their own preparation levels;
              </Line>
              <Line>an Indian citizen residing in India;</Line>
              <Line>legally eligible to enter into a contract;</Line>
              <Line>
                must be registered Unacademy user(s) or must have
                enrolled/registered for the Contest(s) during the registration
                period;
              </Line>
              <Line>
                have age and educational qualifications within the limits
                defined for eligibility of the specific competitive exam that
                they are appearing for.
              </Line>
            </ol>
          </Line>
          <Line>
            It is clarified that Participants do not need to make purchase of
            any goods or services from Unacademy or any other person to
            participate in the Contest(s). Participation in the Contest(s) is
            voluntary and meant only to encourage Participants in their
            preparation.
          </Line>
          <Line>
            Information as available on the official page of the Contest(s) or
            communicated on Unacademy’s official social media handles shall be
            the only authentic and valid information about the Contest(s).
            Unacademy shall not be responsible for any incorrect/misleading
            information relating to the Contest(s), presented/ displayed on any
            other source other than the page of the Contest(s) on the Unacademy
            website. Unacademy will not be liable for any loss suffered by any
            Participant based on the representation, terms, conditions, and the
            information presented/displayed on any other source other than the
            pages of the Contest(s).
          </Line>
          <Line>
            To register for the Contest(s), Participant/s must follow the
            following steps:
            <ol type="a">
              <Line>
                Registrations for the Contest(s) shall be as per the Schedule
                decided by Unacademy from time to time.
              </Line>
              <Line>
                An existing subscriber to the Unacademy Platform can register at
                any time. Non-subscribers may require registration.
              </Line>
              <Line>
                A first-time user and non-subscriber to the Unacademy Platform
                can use the available referral code to register for the
                Contest(s).
              </Line>
            </ol>
          </Line>
          <Line>
            Contest(s) shall be conducted on such dates as may be specified in
            the Contest(s) page. Contest(s) may have such categories as required
            depending on variations in syllabus.
          </Line>
          <Line>
            Contest(s) shall be for a duration of 45 minutes or such other
            duration as specified on the Content(s) page. Responses to the
            Contest(s) questions must be submitted by the Participant while the
            Contest(s) and the questions are live. Contest(s) are available only
            for one time participation by an individual irrespective of whether
            multiple/unique log-in credentials were used. Participants shall not
            be allowed to restart the Contest(s) if they fail to log-in when the
            Contest(s) begin. Participants are not allowed to log out and then
            subsequently log in to complete/redo the test through the same or
            different credentials. Unacademy shall not be responsible for any
            failure to log-in or complete the Contest(s) due to any technical
            issues either at Unacademy’s or Participants’ end.
          </Line>
          <Line>
            Unacademy may disqualify any Participant(s), without assigning any
            reason or being liable in any manner, if in Unacademy’s sole
            discretion, there is reason to believe that any unethical or
            fraudulent or unprofessional or unwarranted means were used by any
            Participant(s) to gain an advantage in the Contest(s).
          </Line>
          <Line>
            Participant Ranking:
            <ol type="a">
              <Line>
                Ranking shall be based, including but not limited to, speed,
                time taken, number of correct answers and other internal metrics
                and algorithms as may be decided by Unacademy. The product
                algorithm evaluates Participants based on the speed and accuracy
                of the answers to display on the leaderboard.
              </Line>
              <Line>
                Every Participant shall have a different rank and no two
                Participants shall share a rank.
              </Line>
              <Line>
                A leaderboard after each question shall display the rankings and
                ratings of each Participant and a final leaderboard shall
                display the winners of the Contest(s).
              </Line>
              <Line>
                Rankings are only the result of a mock examination and are in no
                way indicative of the abilities or inabilities of any
                Participant.
              </Line>
            </ol>
          </Line>
          <Line>
            Prizes: A scholarship/discount on an Unacademy Plus Subscription of
            six months or above subject to the terms and conditions stated on
            this page. Participants obtaining higher ranking will be eligible
            for higher scholarship/discount. Top Rankers only shall be eligible
            for scholarship/discount. The offer of scholarships/discounts must
            be availed within the validity period as intimated and shall
            lapse/expire thereafter. Unacademy shall not entertain any requests
            after expiry of the 10 day period. Scholarships are not available
            for ICONIC subscriptions and full payment must be made for ICONIC
            component after purchase of Unacademy Plus Subscription (along with
            scholarship/discount). No other discounts or offers can be clubbed
            with this offer. Existing subscribers to the Unacademy Plus
            Subscription are not eligible to avail the scholarship and no
            requests for adjustments or refunds shall be entertained. A
            participant can avail of a scholarship only once in 180 days.
            Scholarships cannot be exchanged, sold, assigned or converted to
            value. At its sole discretion Unacademy may change prizes at any
            time.
          </Line>
          <Line>
            A learner who wins a scholarship and elects or fails to utilise the
            scholarship code on two occasions, shall no longer be eligible to
            get any further scholarship codes and all scholarships already
            granted shall also lapse. However, such learners may continue to
            participate as many times they wish. This is done to enable other
            learners who may need scholarship support.
          </Line>
          <Line>
            Lucky Draw: Participants who do not qualify for the scholarship and
            do not have any active subscription with Unacademy shall be eligible
            for the Surprise Lucky Draw Contest. Lucky Draw winners will be
            selected via random selection and the same will be communicated to
            the Participant via email/call within 7 days of completion of the
            Test. The Lucky Draw winners shall get a gift which shall be decided
            at the sole discretion of Unacademy and the term mentioned herein
            shall be applicable to the Lucky Draw, its winners and gift. At its
            sole discretion Unacademy may change prizes at any time.
          </Line>
          <Line>
            Unacademy Notes : Existing subscribers to the Unacademy Plus
            Subscription are not eligible to avail the Unacademy Notes as reward
            from Combat and no requests for adjustments or refunds shall be
            entertained. Only learners who purchase the Unacademy Plus
            Subscription using scholarship code from Combat will be eligible for
            Unacademy Notes. At its sole discretion Unacademy may change prizes
            at any time.
          </Line>
          <Line>
            Unacademy shall be entitled to conduct such audits/evaluation as it
            deems fit, during or after the Contest(s), to determine if
            Participants have conducted themselves in accordance with these
            Terms and Conditions.
          </Line>
          <Line>
            If at any point it is discovered that a Participant has engaged in
            unethical conduct including but not limited to having prior access
            to the questions in the Contest(s), use of any circumventing
            technology/means to manipulate the product algorithm or external
            assistance or any act giving the Participant an unjust or
            unwarranted advantage over other Participants, Unacademy may at its
            sole discretion, without being liable in any manner, cancel any
            prize or reward and bar the Participant from using any product or
            services offered by Unacademy.
          </Line>
          <Line>
            All prizes and rewards are subject to Participants adhering to the
            Terms and Conditions of the Contest(s) and the terms and conditions
            of use of the Unacademy website.
          </Line>
          <Line>
            Unacademy has endeavored to make all reasonably practicable
            arrangements to minimize communication system difficulties but makes
            no guarantee and therefore shall not be liable for any failures in
            the same or any inability to participate in the Contest(s).
            Unacademy has no liability in case a Participant is unable to
            participate on account of his/her inability to access the Contest(s)
            or the website or for any other reason whatsoever.
          </Line>
          <Line>
            Any Participant found using or participating in the Contest(s)
            through multiple accounts shall be immediately disqualified; shall
            not be eligible for any prizes and shall be barred from
            participating in any future Contest(s) at the sole discretion of
            Unacademy.
          </Line>
          <Line>
            This Contest(s) is open for participation of individuals only.
            Corporates, agencies and any non-human entities or any other persons
            acting on behalf of someone else are not entitled to participate in
            this Contest(s). Unacademy employees and educators or their family
            members are not eligible to participate in the Contest(s).
            Participants must voluntarily participate in good faith in order to
            evaluate their own preparation.
          </Line>
          <Line>
            Unacademy shall have the unfettered right to use the name, image, or
            visual representation, comment, or statement of the prize winners
            for promotional, marketing, and advertising purposes in any media or
            format or for any other objective, as deemed appropriate by
            Unacademy. By participating in the Contest(s) participants are
            consenting to such use.
          </Line>
          <Line>
            A Participant taking part in the Contest(s) and declared to be a top
            ranker but is unable to fulfill any one or more eligibility
            requirements specified herein as on the date of closure of
            Contest(s), shall be disqualified from receiving any prize under the
            Contest(s). Any communication, clarification, query or dispute in
            this regard by the top ranker, or any of the legal heirs/guardians
            of the top ranker in any manner will not be entertained by Unacademy
            and Unacademy’s decision shall be final and binding. Contest(s) are
            run at the sole discretion of Unacademy.
          </Line>
          <Line>
            Top rankers will be contacted by the Unacademy team within 7 days of
            conclusion of the Contest(s). In the event of no
            response/acknowledgment from the concerned top ranker to the email
            communication within 7 days, the prize will be forfeited. Collection
            of Prize shall be subject to:
            <ol type="a">
              <Line>
                Receipt of a confirmation response from toppers within 7 days of
                communication from the Unacademy team
              </Line>
              <Line>Verification of ID</Line>
              <Line>
                Provision of correct and authentic details (address, phone
                number)
              </Line>
            </ol>
          </Line>
          <Line>
            Prize/s shall be chosen/decided by Unacademy and shall be subject to
            the laws of India, including all the tax laws. If applicable, prizes
            will be dispatched in 2-3 weeks and delivered within 90 days after
            successful completion of verification. Unacademy will not share the
            invoice of any prize.
          </Line>
          <Line>
            Unacademy shall not be responsible for any loss or damage of the
            prizes during dispatch or during delivery. Unacademy will not be
            responsible for paying any other tax, fee, etc. on the prizes.
          </Line>
          <Line>
            Unacademy shall not be responsible in any manner for any deficiency
            in performance or characteristics of the prizes and does not make a
            representation about the quality, make, performance, features,
            endurance, finishing, benefits, or fitness of the prizes. Such
            claims must be made against manufacturers or respective service
            providers.
          </Line>
          <Line>
            The prizes are non-endorsable, not-transferable, non-exchangeable,
            non-substitutable and cannot be exchanged for cash for cash
            equivalent. The prizes are offered on a &apos;NO EXCHANGE NO
            REFUND&apos; basis. Apart from the entitlement to the prize/s, the
            top rankers will have no other rights or claims against Unacademy.
          </Line>
          <Line>
            Unacademy reserves the right to modify, add or delete any of the
            terms and conditions at any point of time at its sole discretion
            without serving any prior intimation. Intimation of any change,
            modification, addition, deletion in the terms and conditions of the
            Contest(s) will be updated on this page.
          </Line>
          <Line>
            Any disputes with respect to the Contest(s) shall be subject to the
            sole jurisdiction of courts in Bengaluru, India.
          </Line>
          <Line>
            By taking part in the Contest(s) Participant(s) indemnify Unacademy
            against any claims from any party and consequent losses, damages,
            compensation, whatsoever, that may arise from any use, including but
            not limited to, the publication of response (s) submitted by the
            Participant as a part of, or in association with the Contest(s).
          </Line>
          <Line>
            Unacademy shall not be liable for any failure to comply with its
            obligations caused by weather conditions, fire, flood, strike,
            hurricane, industrial dispute, war, hostilities, terrorist attack,
            political unrest, riots, civil commotion, inevitable accidents, acts
            of God or any other circumstances generally amounting to Force
            Majeure.
          </Line>
          <Line>
            Unacademy shall not be responsible for any loss or damage or claims
            if it discontinues or cancels the Contest(s) for any reason that it
            deems fit. In such an event, Participant/s shall be informed of
            discontinuance/cancellation as soon as possible.
          </Line>
          <Line>
            Unacademy shall not be liable to any Participant for any damage,
            loss, cost, claim, liability, or expense (including legal costs and
            expenses) caused to or incurred by any act, omission, or
            representation in respect of the prize or Contest(s). Liability, if
            any, shall be limited to the value of the prize and no other amount.
            Participation in the Contest(s) is purely voluntary.
          </Line>
          <Line>
            For the Unacademy x Gate Academy Combat held on 25th September
            across GATE & ESE goals, following additional terms and conditions
            will apply:
            <ol type="a">
              <Line>
                The Unacademy Combat Contest – GATE &ESE (all goals) (“
                <strong>Contest</strong>”) is organised by M/s Sorting Hat
                Technologies Private Limited (“<strong>Unacademy</strong>”). The
                Contest shall be governed by the following terms and conditions
                (“<strong>Contest Terms</strong>”) the Unacademy Combat Terms
                and Conditions and all other polices and terms and conditions
                (hereinafter collectively referred to as “
                <strong>Platform Terms</strong>”) available on{' '}
                <Home href="/">www.unacademy.com</Home> and the Unacademy Apps
                (“<strong>Platform</strong>”).
              </Line>
              <Line>
                All capitalized terms not defined in the Contest Terms shall
                have the meaning assigned to it under the Platform Terms and in
                the event of conflict, the Contest Terms shall prevail unless
                specified otherwise.
              </Line>
              <Line>
                The (i) eligibility criteria for participating in the Contest
                (ii) Contest structure (iii) terms and conditions around
                rewards/scholarship and (iv) any other terms and condition not
                explicitly provided in the Contest Terms shall be (i) as per the
                Platform Terms and/ or (ii) as per the details as specified from
                time to time of the official landing page of the Contest.
              </Line>
              <Line>
                The individuals who register/sign up for the Contest shall be
                referred to as “<strong>Participants</strong>”. The Participants
                shall receive a final rank for the Contest (‘
                <strong>Ranker/s</strong>”) , on the basis of which they shall
                be eligible for the rewards as provided herein (“
                <strong>Rewards</strong>”).
              </Line>
              <Line>
                At the time of registration/sign up for the Contest, the
                Participant shall be required to select any one of the following
                goals (i) GATE& ESE EE/ECE, (ii)GATE& ESE ME-CH, (iii) GATE &
                ESE Civil and (iv) GATE& ESE CS & IT (“<strong>Goals/s</strong>
                ”) under which the Participant wishes to participate in the
                Contest, wherein the Participant shall be able to select the
                branch under which the participant will want to attempt the test
                (“<strong>Branch</strong>”). The Rankers may be classified on
                the basis of the Goal they have selected and subsequently shall
                receive Rewards subject to the same.
              </Line>
              <Line>
                A Ranker shall be eligible for (i) a scholarship in the form of
                a discount towards a plus subscription on the Platform for the
                Goal they have selected at the time of registration (“
                <strong>Scholarship</strong>”) or (ii) a prize as determined by
                Unacademy (“<strong>Prize</strong>”) or (iii) both (i) and (ii).
                At the discretion of Unacademy, once the final ranks for the
                Contest are announced, the Rankers may be eligible for one of
                the following Reward
                <ol>
                  <Line>
                    Up to 100% scholarships for the Rankers, subject to which
                    Goal the have opted for at the time of participation in the
                    Contest as provided in Table 1.
                  </Line>
                  <Line>
                    Rankers may become eligible for the Prizes provided Table 2
                    in along with the Scholarship, at the sole discretion of
                    Unacademy.
                  </Line>
                </ol>
              </Line>
              <Line>
                The Scholarships shall be limited to a 12 month online plus
                subscription for the Branch under a Goal which the Ranker
                selected at the time of registration for the Contest, on the
                Platform, which is to be availed on or before the date as may be
                communicated by Unacademy.
              </Line>
              <Line>
                The reimbursement of any engineering tuition fee shall be
                limited to the tuition fee already paid by the Ranker for the
                current academic year for the Rankers who receive “Rank 1” in
                the Contest for each Branch, capped at INR 1 Lakh , and shall
                not include any additional charges including without limitation,
                hostel fee, transport fee, mess fee etc. It is hereby clarified
                that Unacademy shall not entertain any request for
                reimbursements of tuition fee for any upcoming academic year.
                The Ranker shall be required to submit a valid receipt for the
                same and provide any other additional information as requested
                by Unacademy further, this specific Prize will have to be
                availed by on or before the end of the current academic year and
                shall be subject to due check and additional terms and
                conditions as may be specified by Unacademy.
              </Line>
              <Line>
                Reimbursement of the GATE 2023 examination registration fee
                shall be subject to submission of the GATE 2023 admit card,
                within 15 days from release of the same to Unacademy, and only
                for the top 500 Rankers from each Branch under each Goal. The
                registration fee shall be reimbursed to the eligible Ranker
                within 60 days of submission of the admit cards to Unacademy.
              </Line>
              <Line>
                The disbursement of any Prize shall be subject to the
                availability of the good and Unacademy may at its sole
                discretion change/replace the Prizes, further Unacademy does not
                make any representation on the fitness or quality of the goods
                and disclaims any liability towards the same. Any spare parts or
                accessories related to the Prizes shall not be provided by
                Unacademy and the Ranker/Participants may purchase the same
                independently. Existing subscribers to the Unacademy plus
                subscription are not eligible to avail the prizes.
              </Line>
              <Line>
                Unacademy shall have the sole discretion to discontinue / cancel
                the Contest or any part thereof at any point in time and the
                Participant shall not raise any claim due to such
                discontinuation or cancellation at any time whatsoever.
              </Line>
            </ol>
          </Line>
          <CombatTerms>
            <Image
              data-image-preview
              src="/combat/combat-terms-table.png"
              alt="combat-terms"
              width="800px"
              height="800px"
              objectFit="contain"
              priority
            />
          </CombatTerms>
          <Line>
            Any information concerning the Contest(s) can be received by
            emailing at
            <StyledAnchor href="mailto:help@unacademy.com">
              help@unacademy.com
            </StyledAnchor>
          </Line>
        </ol>
      </RightContainer>
    </>
  );
};

Terms.pageInfo = {
  name: 'Unacademy Combat Terms',
  isMWebSupported: true,
  layoutOptions: {
    disableDarkMode: true
  }
};

export default Terms;
Terms.Layout = Layout;
Terms.Wrapper = PageReduxProvider;
